import { AccountPaymentItem } from '../../../models/account-payment-item';
import { PaymentItemTableConfiguration } from '../../../models/payment-item-table-configuration';

export class PaymentItemTableSettings {
	configuration: PaymentItemTableConfiguration;
	items: AccountPaymentItem[] = [];
	businessKey: number;
	customerAccountKeys: number[] = [];
	forceRefreshOfData: boolean;
	displayMinPaymentDue: boolean;
	portalMinimumPaymentAmount: number;
	portalMaximumPaymentAmount: number;
	isBusinessBucketEnabled: boolean;
	isShoppingCartEnabled: boolean;
	displayCustomerAccountName: boolean;
}
